import { IconWithTooltip } from '../../Icon'

import UsersIcon from '../../../icons/users-1.svg'

function ChatTableRowTitleGroupChatIcon({ tooltipProps }) {
  return <IconWithTooltip {...tooltipProps} Icon={UsersIcon} />
}

export default ChatTableRowTitleGroupChatIcon
